import {
    GET_PRICE_INFO,
    SET_PRICE_INFO
} from "./PriceInfoType"

const getPriceInfo = (data: any) => ({
    type: GET_PRICE_INFO,
    data
});

const setPriceInfo = (priceInfo: any) => ({
    type: SET_PRICE_INFO,
    priceInfo
});

export {
    getPriceInfo,
    setPriceInfo
}
